module.exports = __webpack_public_path__ + "static/img/safeProduction.35a9339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/safeProduction.jpg
// module id = M/Yr
// module chunks = 4